import React from 'react';
import { PackageIcon } from 'lucide-react';
import { volumes } from '../data/content';
import { toneAt } from '../utils/iconTones';
import { Accent, SectionHeading } from './SectionHeading';
export function VolumesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="volumenes-titulo" data-id="element-193" data-mp="cnzdddqgcvcf">
      <div className="mx-auto max-w-5xl" data-id="element-194" data-mp="7nbq935cgynh">
        <SectionHeading id="volumenes-titulo" badge="Los 6 volúmenes del Mega Kit" badgeIcon={PackageIcon} title={<>
              Cobertura Técnica Integral: <Accent data-id="element-196" data-mp="3pvas48vf9tar">Del Sensor Hasta La Industria 4.0</Accent>
            </>} subtitle="6 volúmenes digitales con arquitectura pedagógica clara, protocolos de laboratorio y toda la integración moderna, listos para tu clase hoy." data-id="element-195" data-mp="3g4g87b5nf5sh" />

        <ol className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-197" data-mp="2xcdn9nlz53cf">
          {volumes.map(({
          icon: Icon,
          number,
          title,
          description
        }, index) => <li key={number} className="flex h-full gap-2.5 rounded-lg border border-cream-300/70 bg-cream-50 p-3 transition-colors duration-150 ease-out hover:border-ember-400/60" data-id="element-198" data-mp="29epdi8cs68uj" data-mpi={index}>
              <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md ${toneAt(index).bg}`} data-id="element-199" data-mp="2j63hotfofwu0">
                <Icon className={`h-3 w-3 ${toneAt(index).fg}`} aria-hidden="true" data-id="element-200" data-mp="1qhfu2r7ggvda" />
              </span>
              <div className="min-w-0" data-id="element-201" data-mp="1vexwdyqywccb">
                <h3 className="text-[0.8rem] font-semibold leading-tight text-forest-800" data-id="element-202" data-mp="1vhtqtd3lwiw0">
                  <span className="text-forest-400" data-id="element-203" data-mp="20divtvyearzp">V{number}.</span> {title}
                </h3>
                <p className="mt-1 text-[0.72rem] leading-snug text-forest-700/85" data-id="element-204" data-mp="24hqkxu8rm9yg">{description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}